module.exports = __webpack_public_path__ + "static/media/link-to-metamask.cfce513d.svg";